import * as React from 'react'
import {observer} from 'mobx-react'
import cn from 'classnames'
import {useStores} from '../../../../lib/MobXProvider'
import {WidgetApi} from '../../../../lib/WidgetApi'
import {DynamicSlotName} from '../../../../lib/DynamicSlotName'
import {ErrorMessage} from '../../../ui/ErrorMessage'
import {DynamicSlot} from '../../../dynamic/DynamicSlot'
import {WidgetEventName} from '../../../../lib/WidgetEventer'
import {InputRadioWrapper} from '../../../wrappers/InputCheckableWrapper'
import {RippleWrapper} from '../../../wrappers/RippleWrapper'
import {DirtyWrapper} from '../../../wrappers/DirtyWrapper'

///////////////////////////////////////////////////////////////////////////////

export const PaymentPurposes = observer(() => {
  const {api} = useStores<{api: WidgetApi}>()
  const form = api.paymentForm
  const errors = form.validationErrors
  const purposes = form.getPossiblePurposes()

  return (
    <div className="payment-purposes">
      <DynamicSlot name={DynamicSlotName.PURPOSES_START} form={form} />

      <fieldset className="main">
        <legend>{api.trans('blocks.payment_purposes.legend')}</legend>
        <div className="purposes">
          {purposes.map((purpose, key) => {
            const isCurrentPurpose = form.getPurpose() === purpose
            const setPurpose = async () => {
              form.setPurpose(purpose)
              await api.events[WidgetEventName.PURPOSE_CHANGED].publish({api})
            }

            return (
              <RippleWrapper key={key}>
                <label
                  className={cn('label-radio-block', 'purpose', {
                    selected: isCurrentPurpose,
                  })}
                >
                  <InputRadioWrapper innerStyle="tick">
                    <DirtyWrapper form={form} fields="purpose">
                      <input
                        type="radio"
                        aria-describedby={api.ui.generateUniqueElementId(
                          'purpose-error',
                        )}
                        className="input-radio"
                        name="purpose"
                        value={purpose}
                        checked={isCurrentPurpose}
                        onChange={setPurpose}
                      />
                    </DirtyWrapper>
                  </InputRadioWrapper>
                  <span className="title">
                    {api.trans(`purposes.${purpose}`)}
                  </span>
                </label>
              </RippleWrapper>
            )
          })}
        </div>
      </fieldset>

      <ErrorMessage
        errors={errors}
        errorKey="purpose"
        id={api.ui.generateUniqueElementId('purpose-error')}
      />

      <DynamicSlot name={DynamicSlotName.PURPOSES_END} form={form} />
    </div>
  )
})
